var _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAllCategoriesImg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 400,
    height: 200,
    viewBox: "0 0 400 200",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 400,
    height: 200,
    fill: "#F6F6FB"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 44,
    y: 24,
    width: 71.3143,
    height: 71.3143,
    rx: 1.64393,
    fill: "#829FF4"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 124.229,
    y: 24,
    width: 71.3143,
    height: 71.3143,
    rx: 1.64393,
    fill: "#829FF4"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 124.229,
    y: 104,
    width: 71.3143,
    height: 71.3143,
    rx: 1.64393,
    fill: "#829FF4"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 204.457,
    y: 24,
    width: 71.3143,
    height: 71.3143,
    rx: 1.64393,
    fill: "#829FF4"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 204.457,
    y: 104,
    width: 71.3143,
    height: 71.3143,
    rx: 1.64393,
    fill: "#829FF4"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 284.686,
    y: 24,
    width: 71.3143,
    height: 71.3143,
    rx: 1.64393,
    fill: "#829FF4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAllCategoriesImg);
export default __webpack_public_path__ + "static/media/all-categories-img.4c489980348015c15667df5b8bfd0507.svg";
export { ForwardRef as ReactComponent };